import { useAnonymousTokenPayload } from './useAnonymousTokenPayload';

export function useAnonymousUserId(): string | null | undefined {
  const tokenPayload = useAnonymousTokenPayload();

  return tokenPayload?.anonymousUserId;
}

export default useAnonymousUserId;
